import { useEffect } from "react";
import "./Index.css";
import { getAllowedMenu } from "utils/Index";
import { IMenuConfiguration } from "./domain/IMenuConfiguration";
import { MenuConfiguration } from "./domain/MenuConfiguration";
import { FullUser } from "authentication/domain/FullUser";
import Menu from "./components/Menu";
import LoginPanel from "./components/LoginPanel";
import ButtonsGroup from "./components/ButtonsGroup";
import { useAppDispatch } from "hooks/hooks";
import {
  getNotAcceptedRequisitions,
  getUnseenMessagesForEmployee,
  getUnseenReports
} from "./dashboard.slice";

interface IProps {
  user?: FullUser;
}

const Dashboard = (props: IProps) => {
  const { user } = props;
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getUnseenMessagesForEmployee());
    dispatch(getNotAcceptedRequisitions());
    dispatch(getUnseenReports());
  }, [dispatch])

  if (user) {
    let menu: IMenuConfiguration = getAllowedMenu(user, MenuConfiguration);

    return (
      <div className="dashboard-container">
        <div className="header">
          <span>Design by Smart Lab solutions</span>
        </div>
        <div className="content">
          <Menu menu={menu} />
          <LoginPanel user={user} />
        </div>
        <div className="footer">
          <ButtonsGroup user={user} />
        </div>
      </div>
    );
  }

  return null;
};

export default Dashboard;
